// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

function createSupabaseClient() {
  // Use import.meta.env for client-side (Vite build-time replacement)
  // Fall back to process.env for SSR (server-side rendering)
  // Safely check for process.env so Vite doesn't throw ReferenceError
  const getEnv = (key: string) => {
    try {
      return typeof process !== "undefined" ? process.env[key] : undefined;
    } catch {
      return undefined;
    }
  };

  const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || getEnv("SUPABASE_URL");
  const SUPABASE_PUBLISHABLE_KEY =
    import.meta.env.VITE_SUPABASE_ANON_KEY ||
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
    getEnv("SUPABASE_ANON_KEY") ||
    getEnv("SUPABASE_PUBLISHABLE_KEY");

  if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
    console.error("Supabase env ausente.", {
      hasViteUrl: Boolean(import.meta.env.VITE_SUPABASE_URL),
      hasViteAnon: Boolean(
        import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
      ),
      hasServerUrl: Boolean(getEnv("SUPABASE_URL")),
      hasServerAnon: Boolean(getEnv("SUPABASE_ANON_KEY") || getEnv("SUPABASE_PUBLISHABLE_KEY")),
    });
    throw new Error(
      "Missing Supabase environment variables. Ensure SUPABASE_URL and SUPABASE_ANON_KEY/SUPABASE_PUBLISHABLE_KEY (or VITE_ prefixed versions) are set in your .env file.",
    );
  }

  return createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: typeof window !== "undefined" ? localStorage : undefined,
      persistSession: true,
      autoRefreshToken: true,
    },
  });
}

let _supabase: ReturnType<typeof createSupabaseClient> | undefined;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";
export const supabase = new Proxy({} as ReturnType<typeof createSupabaseClient>, {
  get(_, prop, receiver) {
    if (!_supabase) _supabase = createSupabaseClient();
    return Reflect.get(_supabase, prop, receiver);
  },
});
